import type { ServicePageConfig } from "./types";
import { allConfigPages } from "./services";
import { isServiceCategoryHidden } from "@/lib/booking/hidden-services";

const configMap = new Map<string, ServicePageConfig>();
const enConfigMap = new Map<string, ServicePageConfig>();

for (const config of allConfigPages) {
  // Pausade tjänster får ingen sida och hamnar inte i sitemap.
  if (isServiceCategoryHidden(config.serviceCategory)) continue;
  if (configMap.has(config.slug)) {
    throw new Error(`Duplicate config slug: ${config.slug}`);
  }
  configMap.set(config.slug, config);

  if (config.en) {
    if (enConfigMap.has(config.en.slug)) {
      throw new Error(`Duplicate EN config slug: ${config.en.slug}`);
    }
    enConfigMap.set(config.en.slug, config);
  }
}

/** Look up a config-driven page by slug. Returns null if not found. */
export function resolveConfigSlug(slug: string): ServicePageConfig | null {
  return configMap.get(slug) ?? null;
}

/** Return all config-driven slugs for generateStaticParams + sitemap. */
export function getAllConfigSlugs(): string[] {
  return [...configMap.keys()];
}

/** Look up a config-driven page by its English slug. Returns null if not found. */
export function resolveConfigEnSlug(slug: string): ServicePageConfig | null {
  return enConfigMap.get(slug) ?? null;
}

/** Return all English config-driven slugs for generateStaticParams + sitemap. */
export function getAllConfigEnSlugs(): string[] {
  return [...enConfigMap.keys()];
}
